import axios from "axios";

let axiosInstance = axios.create({
  //baseURL: "https://medapi.cravewave.in/"
  //baseURL:"https://localhost:7124/"
  
  baseURL:"https://medengageapi.metropolisindia.com/"
  // baseURL:"http://UATMedApi.cravewave.in/"
});

// Add Authorization header to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;



